import { useEffect, useState } from 'react';
import { Network } from '@capacitor/network';

/** Filet de sécurité : le réseau peut revenir avant d'être utilisable, ou l'API être en panne. */
const RETRY_INTERVAL_MS = 15_000;

interface NetworkRetry {
    waiting: boolean;
    setWaiting: (waiting: boolean) => void;
    /** À mettre dans les dépendances de l'effet à relancer. */
    attempt: number;
}

/**
 * Attente du réseau : tant que `waiting`, `attempt` s'incrémente au retour du réseau, au retour
 * au premier plan et à intervalle régulier.
 */
export function useNetworkRetry(): NetworkRetry {
    const [waiting, setWaiting] = useState(false);
    const [attempt, setAttempt] = useState(0);

    useEffect(() => {
        if (!waiting) return undefined;
        const retry = (): void => setAttempt((count) => count + 1);
        const onForeground = (): void => {
            if (!document.hidden) retry();
        };
        const networkListener = Network.addListener('networkStatusChange', (status) => {
            if (status.connected) retry();
        });
        const interval = window.setInterval(retry, RETRY_INTERVAL_MS);
        document.addEventListener('visibilitychange', onForeground);
        return () => {
            document.removeEventListener('visibilitychange', onForeground);
            window.clearInterval(interval);
            void networkListener.then((handle) => handle.remove());
        };
    }, [waiting]);

    return { waiting, setWaiting, attempt };
}
